import moment from "moment";
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import useSWR from "swr";
import NotFoundPage from "../../../StoreComponents/NotFoundPage";
import { API } from "../../../StoreComponents/conflict";
import useGetData from "../../../StoreComponents/hooks/useGetData";
import { PostStoreLog } from "../../../StoreComponents/hooks/useStoreLog";
const fetcher1 = (url) =>
  API.get(url, {
    headers: {
      search: `%%`,
    },
  }).then((res) => res.data.data);

const NotGiven = () => {
  // const {user}=useAuth()
  const [limit, setLimit] = useState(50);

  const [pageIndex, setPageIndex] = useState(0);
  const [search, setSearch] = useState("");
  const { CountData } = useGetData();
  const { mutate: mutate4 } = CountData();
  // get Done Requisition
  const {
    data: notGivenRequisition,
    error: error1,
    mutate,
  } = useSWR(
    `store/requisition/done/all?page=${pageIndex}&limit=${limit}&given=0`,
    fetcher1
  );
  // console.log(notGivenRequisition);

  // Search Implement
  const handleSearch = async (e) => {
    e.preventDefault();
    const search = e.target.value;
    setSearch(search);
    let limit = search === "" ? 10 : 1000;
    const res = await API.get(
      `store/requisition/done/all?page=${pageIndex}&limit=${limit}&given=0`,
      {
        headers: {
          search: `%${search}%`,
        },
      }
    )
      .then((res) => res.data.data)
      .catch((error) => {
        if (error.name === "TypeError") {
          console.log("Data not found for the quary");
        }
      });
    if (res) {
      mutate(res, false);
    } else {
      mutate([], false);
    }
  };

  const handleGivenCheck = (id) => {
    // console.log(id);

    swal({
      title: "Are you sure?",
      //  text: "Once deleted, you will not be able to recover this imaginary file!",
      buttons: true,
      //  dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        API.put(`store/requisition/given/${parseInt(id)}`, {}).then((res) => {
          // console.log(res);
          PostStoreLog(2, "Store Product given");
          mutate();
          mutate4();
        });
      } else {
        swal("Your imaginary file is safe!");
      }
    });
  };

  let count = 1;
  return (
    <>
      <Helmet>
        <title>Not Given Requisition - BBA STORE</title>
        <meta name="description" content="View Requisition - BBA STORE" />
      </Helmet>
      <style type="text/css">
        {
          "table th ,table  td{ font-size:1.1rem} label{font-size:1rem !important}"
        }
      </style>
      <div className="page-wrapper">
        <div className="content container-fluid main-container">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h3 className="text-start text-dark">Not Given Requisition List</h3>
          </div>

          <div
            className="my-4 table-container p-2"
            style={{ background: "white", borderRadius: "10px" }}
          >
            <div className="d-flex justify-content-between align-items-center search-div">
              <div className="col-12 col-md-4 col-lg-4">
                <p className="text-start mt-4 fs-6 text-black-50">
                  Show Entries :
                  <select
                    onClick={(e) => {
                      setLimit(parseInt(e.target.value));
                    }}
                    className="ms-2 btn-outline-color "
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </p>
              </div>

              <div className="col-12 col-md-4 col-lg-4">
                <input
                  className="p-2 input-field_store w-100"
                  type="text"
                  name="Search"
                  onChange={(e) => handleSearch(e)}
                  placeholder="Search Requisitions"
                />
              </div>
            </div>
            {!notGivenRequisition ? (
              <NotFoundPage />
            ) : (
              <div className="table-responsive data-table">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr className="tableColor">
                      <th>S/N</th>
                      <th>Date </th>
                      <th>RID </th>
                      <th>Name</th>
                      <th>Designation</th>
                      <th>Department</th>
                      <th>Requisitions</th>
                      <th>Approved</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {notGivenRequisition.map((product) => (
                      <tr key={count}>
                        <th>{count++}</th>
                        <td>
                          {moment(new Date(product.REQUIDATE)).format(
                            "DD-MM-YYYY"
                          )}
                        </td>
                        <td>{product.REQUISITIONNO}</td>
                        <td>{product.NAME_ENGLISH}</td>
                        <td>{product.DESIGNATION}</td>
                        <td>{product.DEPARTEMENT}</td>
                        <td className="text-center">{product.req_qty}</td>
                        <td className="text-center">{product.approved_qty}</td>
                        <td className="text-center">
                          <Link to={`/requisitions/done/slip/${product.REQID}`}>
                            <button
                              data-bs-toggle="tooltip"
                              title="View"
                              type="button"
                              className="btn btn-red_store px-3"
                            >
                              <i className="fa fa-eye"></i>
                            </button>
                          </Link>
                          <button
                            data-bs-toggle="tooltip"
                            title="View"
                            type="button"
                            onClick={() => {
                              handleGivenCheck(product.REQID);
                            }}
                            className="btn btn-danger ms-2 px-3"
                          >
                            <i className="fa fa-check fw-bold"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {search.length > 0 ? (
              <div></div>
            ) : (
              <div className="text-end mt-4 mb-3">
                {pageIndex > 0 && (
                  <button
                    type="button"
                    className="btn btn-outline-color_store px-4 me-2"
                    onClick={() => setPageIndex(pageIndex - 1)}
                  >
                    Previous
                  </button>
                )}

                {notGivenRequisition && notGivenRequisition.length === limit ? (
                  <button
                    type="button"
                    className="btn btn-outline-color_store px-4 me-2"
                    onClick={() => setPageIndex(pageIndex + 1)}
                  >
                    Next
                  </button>
                ) : (
                  ""
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default NotGiven;
